import { FontLineHeightMd, FontSize200, FontSize300 } from "@nxt-costco-com/forge-design-tokens";
const buttonStyles = {
  display: "flex",
  flexDirection: "column",
  width: "fit-content"
};
const iconStyles = {
  display: {
    lg: "none"
  },
  height: {
    xs: "22px"
  },
  width: {
    xs: "22px"
  }
};
const textStyles = {
  color: "inherit",
  fontSize: {
    lg: FontSize300,
    md: FontSize200,
    sm: ".625rem"
  },
  lineHeight: {
    lg: FontLineHeightMd,
    md: FontLineHeightMd,
    sm: "14px"
  },
  width: "fit-content"
};
export {
  buttonStyles,
  iconStyles,
  textStyles
};
